import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import globals from '#utilities/js/ea/globals.js'
import href from '#utilities/js/ea/href.js'
import { scopeProps } from './props.js'
import { elements } from '../../styles.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: () => {
    const { meet_id } = scopeProps()
    const elt = one(`.${elements.meet}`)
    globals.ea_link(href('chat/meet',
        { id: meet_id, join: 1 }),
      elt.id,
      null
    )
  }
})

export default span => {
  onClick.listen(span)
}
